import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { allFilterPages } from '@features/filter/static/filterUtil';
import CheckBoxWithAll from '@features/filter/v2/CheckBoxWithAll';
import FilterName from '@features/filter/v2/FilterName';

const Stackholder = ({ filterPageName }) => {
	const [data, setData] = useState([]);
	const [allData, setAllData] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);

	useEffect(() => {
		onFetchData();
	}, [dependentFilterList]);

	useEffect(() => {
		setData(allData);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.MY_COLLEAGUES]: dependentFilterList?.stakeholderList
	};

	const onFetchData = async () => {
		let responseData = filterData[filterPageName] || [];
		responseData = responseData?.map((item) => {
			return {
				...item,
				id: item.id,
				name: item.text
			};
		});

		setAllData([{ id: 'ALL-STACKHOLDER', name: 'All' }, ...responseData]);
		setData([{ id: 'ALL-STACKHOLDER', name: 'All' }, ...responseData]);
	};

	const handleSearch = (e) => {
		let searchResult = e.target.value
			? allData?.filter((item) => item?.name?.toLowerCase().includes(e.target.value.toLowerCase()))
			: allData;
		setData(searchResult);
	};

	return (
		<>
			<FilterName type="STACKHOLDER" />
			<CheckBoxWithAll data={data} type="STACKHOLDER" handleSearch={handleSearch} />
		</>
	);
};

export default Stackholder;
